// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const ImportExportIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M6.23 21.9c-.78 0-1.41-.62-1.41-1.4V8.97H2.91c-.55 0-1.04-.31-1.27-.8-.24-.5-.17-1.08.18-1.5l3.26-3.99c.5-.7 1.74-.72 2.27-.03l3.3 4.02c.34.42.4 1 .17 1.5-.23.49-.73.8-1.27.8H7.64V20.5c0 .78-.63 1.4-1.41 1.4" />
      <path
        d="M17.77 21.9c-.47 0-.89-.22-1.14-.58l-3.27-3.99c-.34-.42-.42-1-.18-1.5.23-.49.73-.8 1.27-.8h1.91V3.5c0-.78.63-1.4 1.41-1.4s1.4.62 1.4 1.4v11.53h1.92c.55 0 1.04.31 1.28.8s.16 1.08-.19 1.5l-3.3 4.03c-.25.33-.65.55-1.11.55"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default ImportExportIcon;
